import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useProfileQuery } from "@/hooks/profile/useProfileQuery";

interface UpdateGymReservationMessageData {
  gymId: string;
  message: string;
}

export const useUpdateGymReservationMessage = () => {
  const queryClient = useQueryClient();
  const { data: profile } = useProfileQuery();

  return useMutation({
    mutationFn: async (data: UpdateGymReservationMessageData) => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user || !profile) throw new Error("Usuario no autenticado");

      // Verify manager has access to this gym
      const { data: gymManager } = await supabase
        .from('gym_managers')
        .select('*')
        .eq('manager_id', user.id)
        .eq('gym_id', data.gymId)
        .maybeSingle();

      if (!gymManager && profile.role !== 'admin') {
        throw new Error("No tienes permisos para actualizar el mensaje de este gimnasio");
      }

      const { error } = await supabase
        .from('gyms')
        .update({ reservation_message: data.message })
        .eq('id', data.gymId);

      if (error) throw error;

      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['gym-reservation-message', data.gymId] });
      toast.success("Mensaje actualizado exitosamente");
    },
    onError: (error) => {
      toast.error("Error al actualizar el mensaje: " + error.message);
    },
  });
};